var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart-card',{attrs:{"size":_vm.size,"title":_vm.title,"value":_vm.data,"init-total":_vm.total,"unit":_vm.unit,"isMoveWrite":_vm.isMoveWrite,"is-move-detail":_vm.isMoveDetail,"orientation":_vm.orientation},on:{"detail":_vm.onClickDetail,"write":_vm.onClickWrite}})
}
var staticRenderFns = []

export { render, staticRenderFns }